"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ElementOption = /** @class */ (function () {
    function ElementOption(
    /**
     * Name of the option
     */
    name, 
    /**
     * Value of the option
     */
    codename) {
        this.name = name;
        this.codename = codename;
    }
    return ElementOption;
}());
exports.ElementOption = ElementOption;
//# sourceMappingURL=element-option.class.js.map